import {ReadyProvider} from '../../../application/providers/readyProvider';
import {Form} from '../../../application/forms/form';

ReadyProvider.executeOnReady(() => {
    new Form(document.querySelector('[data-register="form"]'));
});
